import {combineReducers} from 'redux';
import Definition from './Definition/Module';
import Assignment from './Assignment/Module';

const reducers = combineReducers({
  Definition,
  Assignment,
});

export default reducers;
